// extracted by mini-css-extract-plugin
module.exports = {"gc":"styles_gc__Z_m6V"};